export function RadioHalfBlackIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_590_35462)">
        <rect width="18" height="18" rx="9" fill="#101828" />
        <path d="M5 9H13" stroke="white" stroke-width="2" stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_590_35462">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

RadioHalfBlackIcon.displayName = 'RadioHalfBlackIcon';
